import { useState } from 'react';

import './image-button.css';

interface ImageButtonProps {
    imageSrc: string;
    alt: string;
    onClick: () => void;
    onHoverImageSrc?: string;
    height?: string;
    width?: string;
}

function ImageButton(props: ImageButtonProps) {
    const { imageSrc, alt, onClick, onHoverImageSrc, height, width } = props;
    const [isHovered, setIsHovered] = useState(false);

    const imageStyle: React.CSSProperties = {};
    if (height) {
        imageStyle.height = height;
    }
    if (width) {
        imageStyle.width = width;
    }

    return (
        <div
            className="image-button-wrapper"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <button
                className="image-button"
                onClick={onClick}
                // Prevents the item from focusing, which resolves a bug
                // where clicking an item, then pressing enter to resolve another
                // effect will cause it to "click" the item again.
                onMouseDown={(event) => {
                    event.preventDefault();
                }}
            >
                <img
                    src={isHovered ? onHoverImageSrc || imageSrc : imageSrc}
                    alt={alt}
                    style={imageStyle}
                />
            </button>
        </div>
    );
}

export default ImageButton;
